import btc from "@/public/benefits/bitcoin.png"
import usdt from "@/public/benefits/usdt.png"
import usdc from "@/public/benefits/usdc.png"
import sol from "@/public/benefits/sol.png"
import card from "@/public/benefits/card.png"
import complete from "@/public/benefits/complete.png"
import fast from "@/public/benefits/fast.png"
import instusdt from "@/public/benefits/instant-usdt.png"
import instusdc from "@/public/benefits/instant-usdc.png"
import instbtc from "@/public/benefits/instant-btc.png"
import instsol from "@/public/benefits/instant-sol.png"
import instangn from "@/public/benefits/instant-ngn.png"
import instakenya from "@/public/benefits/instant-kenya.png"
import instaghana from "@/public/benefits/instant-ghana.png"
import user1 from "@/public/benefits/user1.png"
import user2 from "@/public/benefits/user2.png"
import img from "@/public/benefits/img.png"
import guard from "@/public/benefits/guard.png"

export {
    btc, usdt, usdc, sol, card, complete, fast, instaghana, instakenya, instangn, instbtc, instsol, instusdc, instusdt, user1, user2, img, guard
}